import { authenticatedFetch } from '../utils/api';
import { API_HOST } from '../utils/constants';

export const submitReferenceVideoReverse = ({
  file,
  projectId,
  episodeId,
  provider,
  maxFrames,
  samplingIntervalSeconds,
  extractionMode,
}) => {
  const formData = new FormData();
  formData.append('file', file);
  if (projectId) formData.append('projectId', String(projectId));
  if (episodeId) formData.append('episodeId', String(episodeId));
  if (provider) formData.append('provider', provider);
  if (maxFrames) formData.append('maxFrames', String(maxFrames));
  if (samplingIntervalSeconds) formData.append('samplingIntervalSeconds', String(samplingIntervalSeconds));
  if (extractionMode) formData.append('extractionMode', extractionMode);

  return authenticatedFetch(`${API_HOST}/api/reference-video-reverse/analyze`, {
    method: 'POST',
    body: formData,
    timeout: 600000,
  });
};

export const fetchReferenceVideoReverseStatus = (taskId) => (
  authenticatedFetch(`${API_HOST}/api/reference-video-reverse/status/${encodeURIComponent(taskId)}`)
);

export const fetchReferenceVideoReverseList = ({ projectId } = {}) => {
  const params = new URLSearchParams();
  if (projectId) params.set('projectId', String(projectId));
  const query = params.toString();
  return authenticatedFetch(`${API_HOST}/api/reference-video-reverse/list${query ? `?${query}` : ''}`);
};
